import React, { Component } from 'react';
import logo from './logo.svg';
import Index from './Component/HomePage/Index'
import SideBar from '../src/Component/LeftSideBar/SideBar'
import Bottom from './Component/MblBottom/index'
import SearchHome from './Component/Search/SearchHome'
import HomePage from './Component/TopChips/NavSystem'
import HomePageMobile from './Component/TopChips/NavMobile'
import Popular from './Component/Popular/Popular'
import Sale from './Component/Sale/Sale'
//import Modal from 'react-modal';
import { MobileView, BrowserView } from "react-device-detect";
import { BrowserRouter, Route, Switch, withRouter, Redirect } from "react-router-dom";
import User from './Component/User/User'
import Product from './Component/InProduct/Product'
import login from './Component/login/Login'
import Signup from './Component/Signup/Signup'
import Brand from './Component/Brands/Brand'
import './App.css'
import ReactGA from 'react-ga';
import { isBrowser, isMobile } from "react-device-detect";
import Innerpage from './Component/Search/SearchPage';
import brands from './Component/Search/brands';

ReactGA.initialize('UA-131288747-1');
ReactGA.pageview(window.location.pathname + window.location.search);


/*const list = [

   { name: "Khaadi", value: "1" },
   { name: "Limelight", value: "2" },
   { name: "Sapphire", value: "3" },
   { name: "Gulahmed", value: "4" },
   { name: "J. | JunaidJamshed", value: "5" },
   { name: "Ittehad Textiles", value: "6" },
   { name: "Waniya", value: "7" },
   { name: "Shoes", value: "10" },
   { name: "Jewellery", value: "11" },
   { name: "Dress", value: "12" },
   { name: "Bed Sheet", value: "13" },
   { name: "2PC", value: "14" },
   { name: "3PC", value: "15" },
   { name: "Stitched", value: "16" },
   { name: "Unstitched", value: "17" }
   
];
*/
class App extends Component {

  state = {
    expanded: false,
    modalIsOpen: false,
  }

  expandSideNav = () => {
    this.setState({ expanded: !this.state.expanded })
  };

  render() {

    if (isBrowser)
      return (
        <div>
          {/* {window.location.href.indexOf("search") < 1 ? */}


          {/* <Modal
        isOpen={this.state.expanded}
        onRequestClose={this.state.expanded}

        className="modelApp"
      >
      <SideBar expanded={this.state.expanded} /> 
      </Modal> */}
          {}


          <Switch>
            <Route path="/" exact component={HomePage} />
            <Route path="/home" exact component={HomePage} />
            <Route path="/item/:id" exact component={Product} />
            <Route path="/search" exact component={SearchHome} />
            <Route path="/popular" exact component={Popular} />
            <Route path="/sale" exact component={Sale} />
            <Route path="/user" exact component={User} />
            <Route path="/login" component={login} />
            <Route path="/signup" component={Signup} />
            <Route path="/:brand" component={Brand} />
          </Switch >
        </div>

      )
        ;
    else
      return (
        <div>
          {/* {window.location.href.indexOf("search") < 1 ? */}


          {/* <Modal
        isOpen={this.state.expanded}
        onRequestClose={this.state.expanded}

        className="modelApp"
      >
      <SideBar expanded={this.state.expanded} /> 
      </Modal> */}
          { <MobileView><Bottom /></MobileView>}


          <Switch>
            <Redirect from="/searchpage/:id" to="/searchpage" />
            <Route path="/searchpage" exact component={Innerpage} />
            <Route path="/" exact component={HomePageMobile} />
            <Route path="/home" exact component={HomePageMobile} />
            <Route path="/item/:id" exact component={Product} />
            <Route path="/search" exact component={SearchHome} />
            <Route path="/popular" exact component={Popular} />
            <Route path="/sale" exact component={Sale} />
            <Route path="/user" exact component={User} />
            <Route path="/login" component={login} />
            <Route path="/signup" component={Signup} />
            <Route path="/:brand" component={Brand} />


            {/*
                    list.map
                    (el => {
                            const { name,value } = el;
                        
                     return(   <Route key={value} path={`/${name}`} component={brands}/>);
                            
                    })*/
            }

          </Switch >
        </div>
      );


  }
}

export default withRouter(App);
